var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.20c1532e2ac75115020882fcc1d6e8b7.svg#c';
                    var viewUrl = 'sprites.20c1532e2ac75115020882fcc1d6e8b7.svg#view-c';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 48 48',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };